module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-person"
  }, [_c('el-dialog', {
    attrs: {
      "title": "批量分配",
      "width": "600px",
      "visible": _vm.dialogVisible,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.type === 0) ? [_c('el-input', {
    attrs: {
      "size": "small",
      "prefix-icon": "el-icon-search",
      "placeholder": "员工搜索"
    },
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.nameLike),
      callback: function($$v) {
        _vm.nameLike = $$v
      },
      expression: "nameLike"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "staff"
  }, _vm._l((_vm.userList), function(user) {
    return _c('li', [_c('div', {
      staticClass: "staffLeft"
    }, [_c('img', {
      attrs: {
        "src": user.userAvatar,
        "width": "30"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.userName))])]), _vm._v(" "), [_c('div', {
      staticClass: "rightCheck"
    }, [(user.selectType === 1 && user.isIndeterminate) ? _c('el-checkbox', {
      attrs: {
        "indeterminate": user.isIndeterminate
      },
      on: {
        "change": function($event) {
          _vm.checkedHalf(user)
        }
      }
    }) : _c('el-checkbox', {
      on: {
        "change": function($event) {
          _vm.checkedNoOrYes(user)
        }
      },
      model: {
        value: (user.selected),
        callback: function($$v) {
          _vm.$set(user, "selected", $$v)
        },
        expression: "user.selected"
      }
    })], 1)]], 2)
  }))] : [_c('div', {
    staticClass: "depart"
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.departmentTree,
      "props": _vm.defaultProps,
      "check-strictly": true,
      "default-checked-keys": _vm.selectIds,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "id",
      "highlight-current": "",
      "render-content": _vm.renderContent
    },
    on: {
      "check-change": _vm.departChange
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBution
    }
  }, [_vm._v("保 存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "detail-bg"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6be1d30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/product-person.vue
// module id = 1330
// module chunks = 82